// Port of api/fuel/app/classes/insights/members/listing.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import User from 'offline/model/user'

export default Segment.extend({
	name: 'listing',
	types: [Constants.TYPE_GROUP],
	insight: false,
	default_: false,
	detail: ['list'],
	run: function(type, owner, userIndex) {
		var users = []
		var sorted = User.collection({
			where: [
				['user_id', 'in', userIndex]
			],
			order_by: 'user_sortname ASC'
		})

		for (var i = 0; i < sorted.length; i++) {
			var userId = sorted[i].get_id()
			users.push(userId)
			this._references.users.push(userId)
		}

		return {
			users: users
		}
	}
})
